// MIT License

// Copyright (c) 2020 Kontist GmbH (kontist.com)

// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:

// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.

// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.

import $ from "jquery";
$(document).ready(() => {
  var jsConverterSelector = ".js-tax-number-converter";
  var windowWidth = $(window).outerWidth();

  var $jsTaxnumberConverter = $(jsConverterSelector);
  var $bundeslandSelect = $jsTaxnumberConverter.find(
    "select[name='bundesland']"
  );
  var $stateTaxNumberInput = $jsTaxnumberConverter.find(
    "input[name='steuernummer']"
  );
  var $submitBtn = $jsTaxnumberConverter.find("button.submit");
  var $resetBtn = $jsTaxnumberConverter.find("button.reset");
  var $copyBtn = $jsTaxnumberConverter.find(".converter-result-copy");
  var $result = $jsTaxnumberConverter.find(".converter-result");
  var $error = $jsTaxnumberConverter.find(".converter-error");
  var $picture = $jsTaxnumberConverter.find(".converter-picture");

  $submitBtn.on("click", function() {
    // try to convert tax number & show result or error accordingly
    try {
      var nationalTaxNumber = covertTaxNumber(
        $stateTaxNumberInput.val(),
        $bundeslandSelect.val()
      );
      $picture.hide();
      $error.hide();
      $result.show();
      if (windowWidth < 1040) {
        $result[0].scrollIntoView({
          block: "start"
        });
      }
      $jsTaxnumberConverter
        .find(".converter-result-value")
        .text(nationalTaxNumber);
    } catch (err) {
      $picture.hide();
      $result.hide();
      $error.show();
      if (windowWidth < 1040) {
        $error[0].scrollIntoView({
          block: "start"
        });
      }
    }
  });

  $resetBtn.on("click", function() {
    // clear input, reset slect to 1st option & show picture instead of result/error div
    $bundeslandSelect.val(null).trigger("change");
    $stateTaxNumberInput.val("");
    $picture.show();
    $error.hide();
    $result.hide();
  });

  $copyBtn.on("click", function() {
    // copy to clipboard
    navigator.clipboard.writeText($(".converter-result-value").text());
  });

  /**
   The rest of the code in this file was taken from https://github.com/kontist/normalize-steuernummer & adjusted to fit the project.


    MIT License

    Copyright (c) 2020 Kontist GmbH (kontist.com)

    Permission is hereby granted, free of charge, to any person obtaining a copy
    of this software and associated documentation files (the "Software"), to deal
    in the Software without restriction, including without limitation the rights
    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
    copies of the Software, and to permit persons to whom the Software is
    furnished to do so, subject to the following conditions:

    The above copyright notice and this permission notice shall be included in all
    copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCH
    ANTABILITY,
    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
    SOFTWARE.

 */
  function parse(taxNumber, state) {
    // Remove slashes and spaces as included in official letters.
    var taxNumberNoSpecialChars = taxNumber.replace(/[/ ]/g, "");

    var statesWith10Digits = [
      "baden_wuerttemberg",
      "berlin",
      "bremen",
      "hamburg",
      "niedersachsen",
      "rheinland_pfalz",
      "schleswig_holstein"
    ];
    if (
      taxNumberNoSpecialChars.length !== 10 &&
      statesWith10Digits.indexOf(state) !== -1
    ) {
      throw new TypeError(
        "`taxNumber` for " + state + "must contain exactly 10 digits"
      );
    }

    var statesWith11Digits = [
      "bayern",
      "brandenburg",
      "hessen",
      "mecklenburg_vorpommern",
      "nordrhein_westfalen",
      "saarland",
      "sachsen_freistaat",
      "sachsen_anhalt",
      "thueringen"
    ];
    if (
      taxNumberNoSpecialChars.length !== 11 &&
      statesWith11Digits.indexOf(state) !== -1
    ) {
      throw new TypeError(
        "`taxNumber` for " + state + "must contain exactly 11 digits"
      );
    }

    switch (state) {
      case "baden_wuerttemberg":
      case "berlin":
      case "bremen":
      case "hamburg":
      case "niedersachsen":
      case "rheinland_pfalz":
      case "schleswig_holstein":
        // Format: FF/BBB/UUUUP.
        return taxNumberNoSpecialChars.match(
          new RegExp("(?<ff>\\d{2})(?<bbb>\\d{3})(?<uuuu>\\d{4})(?<p>\\d{1})")
        ).groups;
      case "bayern":
      case "brandenburg":
      case "mecklenburg_vorpommern":
      case "saarland":
      case "sachsen_freistaat":
      case "sachsen_anhalt":
      case "thueringen":
        // Format: FFF/BBB/UUUUP.
        return taxNumberNoSpecialChars.match(
          new RegExp("(?<fff>\\d{3})(?<bbb>\\d{3})(?<uuuu>\\d{4})(?<p>\\d{1})")
        ).groups;
      case "hessen":
        // Format: 0FF/BBB/UUUUP.
        return taxNumberNoSpecialChars.match(
          new RegExp("0(?<ff>\\d{2})(?<bbb>\\d{3})(?<uuuu>\\d{4})(?<p>\\d{1})")
        ).groups;
      case "nordrhein_westfalen":
        // Format: FFF/BBBB/UUUP.
        return taxNumberNoSpecialChars.match(
          new RegExp("(?<fff>\\d{3})(?<bbbb>\\d{4})(?<uuu>\\d{3})(?<p>\\d{1})")
        ).groups;
      default:
        throw new TypeError("`state` must be a German ISO 3166-2 code");
    }
  }

  function compile(tokens, state) {
    switch (state) {
      case "baden_wuerttemberg":
        return "28" + tokens.ff + "0" + tokens.bbb + tokens.uuuu + tokens.p;
      case "bayern":
        return "9" + tokens.fff + "0" + tokens.bbb + tokens.uuuu + tokens.p;
      case "berlin":
        return "11" + tokens.ff + "0" + tokens.bbb + tokens.uuuu + tokens.p;
      case "brandenburg":
      case "sachsen_freistaat":
      case "sachsen_anhalt":
        return "3" + tokens.fff + "0" + tokens.bbb + tokens.uuuu + tokens.p;
      case "bremen":
        return "24" + tokens.ff + "0" + tokens.bbb + tokens.uuuu + tokens.p;
      case "hamburg":
        return "22" + tokens.ff + "0" + tokens.bbb + tokens.uuuu + tokens.p;
      case "hessen":
        return "26" + tokens.ff + "0" + tokens.bbb + tokens.uuuu + tokens.p;
      case "mecklenburg_vorpommern":
      case "thueringen":
        return "4" + tokens.fff + "0" + tokens.bbb + tokens.uuuu + tokens.p;
      case "niedersachsen":
        return "23" + tokens.ff + "0" + tokens.bbb + tokens.uuuu + tokens.p;
      case "nordrhein_westfalen":
        return "5" + tokens.fff + "0" + tokens.bbbb + tokens.uuu + tokens.p;
      case "rheinland_pfalz":
        return "27" + tokens.ff + "0" + tokens.bbb + tokens.uuuu + tokens.p;
      case "saarland":
        return "1" + tokens.fff + "0" + tokens.bbb + tokens.uuuu + tokens.p;
      case "schleswig_holstein":
        return "21" + tokens.ff + "0" + tokens.bbb + tokens.uuuu + tokens.p;
    }
  }

  function covertTaxNumber(taxNumber, state) {
    if (typeof taxNumber !== "string") {
      throw new TypeError("taxNumber must be a string");
    }

    if (typeof state !== "string") {
      throw new TypeError("`state` must be a string");
    }

    var tokens = parse(taxNumber, state);
    return compile(tokens, state);
  }

  //
  //
  //
  //
  //
  //
  //

  var $checkSignNumber = $("[data-sign-step]");
  var $backBtn = $(".go-back-call");
  var signStep;

  var checkProp = function(ev) {
    signStep = $(this).data("sign-step");
    // console.log("🦇 Step: " + signStep);
    $("#" + signStep).addClass("selected");
  };

  var backProp = function() {
    var selectorRemoveClass = $(this).attr("onclick");

    var toRemove = selectorRemoveClass.split("."),
      selectorId = toRemove[0].split("'"),
      imgToRemove = $(selectorId[1])
        .next()
        .data("sign-step");

    if (typeof imgToRemove !== "undefined") {
      $("#" + imgToRemove).removeClass("selected");
    } else {
    }
  };

  function initialize() {
    if ($checkSignNumber.length === 0) return false;
    $checkSignNumber.on("click", checkProp);
    $backBtn.on("click", backProp);
  }

  initialize();
});
